<template>
  <div>
    <dictionary-modal-table
      dictionary_link="/brands"
      title="Lista marek"
      :numeral_text="['marka', 'marki', 'marek']"
      :columns_title="['name']"
    ></dictionary-modal-table>
  </div>
</template>

<script>
import DictionaryModalTable from "./DictionaryModalTable.vue";
export default {
  components: {
    DictionaryModalTable,
  },
};
</script>
